<convfact-investment-incompanies-form [investmentInCompanies]="investmentInCompanies" [accounts]="accounts" (onSave)="saveData($event)">
</convfact-investment-incompanies-form>
